import { Component, inject } from '@angular/core';
import { SideNav } from '../layout/side-nav/side-nav';
import { Footer } from '../layout/footer/footer';
import { RouterOutlet } from '@angular/router';
import { LaunchDarklyService, StorageService, StorageType } from '@anddone/ui-utilities';
import { environment } from '../../../environments/environment';
import { AppSetting } from '../../constants/appsetting.constant';

@Component({
  selector: 'app-secure',
  imports: [SideNav, RouterOutlet, Footer],
  templateUrl: './secure.html',
  styleUrl: './secure.scss',
})
export class Secure {
  private storageService = inject(StorageService);
  private launchDarklyService = inject(LaunchDarklyService);
  constructor() {
    const data = this.storageService.get(StorageType.Session, 'userDetails');
    const loggedInUserData = data ? JSON.parse(data) : null;
    const user = {
      id: loggedInUserData?.id,
      name: loggedInUserData?.adminUserName,
    };

    // Initialize LaunchDarkly client with Project Name, Client Key and User details
    this.launchDarklyService.initLDClient(
      AppSetting.launchDarklyProjectName,
      environment.launchDarklyClientKey,
      user
    );
  }
}
